import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-material-button-demo',
  templateUrl: './material-button-demo.component.html',
  styleUrls: ['./material-button-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialButtonDemoComponent {
  public buttons = [
    {
      name: 'Raised button',
      type: 'mat-raised-button',
      disabled: false,
      translation: '+SERVICE_APP.BARCODE_SCANNER.ERROR.CAMERA_ACCESS_DISABLED',
    },
    {
      name: 'Raised button - disabled',
      type: 'mat-raised-button',
      disabled: true,
      translation: '+SERVICE_APP.BARCODE_SCANNER.ERROR.CAMERA_ACCESS_DISABLED',
    },
    {
      name: 'Stroked button',
      type: 'mat-stroked-button',
      disabled: false,
      translation: '+SERVICE_APP.BARCODE_SCANNER.ERROR.CAMERA_ACCESS_DISABLED',
    },
    {
      name: 'Stroked button - disabled',
      type: 'mat-stroked-button',
      disabled: true,
      translation: '+SERVICE_APP.BARCODE_SCANNER.ERROR.CAMERA_ACCESS_DISABLED',
    },
    {
      name: 'Basic button',
      type: 'mat-button',
      disabled: false,
      translation: '+SERVICE_APP.BARCODE_SCANNER.ERROR.CAMERA_ACCESS_DISABLED',
    },
    {
      name: 'Basic button - disabled',
      type: 'mat-button',
      disabled: true,
      translation: '+SERVICE_APP.BARCODE_SCANNER.ERROR.CAMERA_ACCESS_DISABLED',
    },
  ];

  public matTooltipShowDelay = 500;
  public matTooltipHideDelay = 250;

  constructor() {}
}
